/**
 * CRA / webpack-dev-server surfaces a benign browser warning as a red
 * "Uncaught runtime error" overlay when charts (and Ant Design) use
 * ResizeObserver during window resize. Filter that noise so demos and
 * local development are not interrupted.
 *
 * Production builds are unaffected in practice; this only softens the
 * overlay's error-capture path.
 */
const RESIZE_OBSERVER_ERROR_RE =
  /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/i;

export function ignoreResizeObserverOverlayErrors() {
  if (typeof window === 'undefined') {
    return;
  }

  const shouldIgnore = (value) =>
    typeof value === 'string' && RESIZE_OBSERVER_ERROR_RE.test(value);

  window.addEventListener(
    'error',
    (event) => {
      if (shouldIgnore(event.message)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true
  );
}
